// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDtCFq4rPdKCP99eZcAinFPSt-ptw-3ifo",
  authDomain: "boogaverse.firebaseapp.com",
  projectId: "boogaverse",
  storageBucket: "boogaverse.appspot.com",
  messagingSenderId: "861798708845",
  appId: "1:861798708845:web:b749ba0d04be45525fb164",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);